module.exports = __webpack_public_path__ + "static/1-34ad51251b29db1fa6a8641b24ac6340.png";